import { env, G } from '@2l/utils'

const APPLE_CLIENT_WEB_ID = env('APPLE_CLIENT_WEB_ID', 'com.ewa.ewaapp.webapp')

const path = '/auth/callback/apple'
const url = new URL(path, window.location.origin)
const redirectURI = url.toString()
const getToken = G('authorization.code')

class Apple {
  async authenticate() {
    const data = {
      clientId: APPLE_CLIENT_WEB_ID,
      scope: 'name email',
      redirectURI,
      usePopup: true
    }

    try {
      await window.AppleID.auth.init(data)
      const response = await window.AppleID.auth.signIn()
      return getToken(response)
    } catch {
      return Promise.reject(new Error('alert_something_went_wrong'))
    }
  }
}

export default Apple
